import React, { useRef } from 'react';
import Icon from '@mdi/react';
import { mdiPlusCircleOutline } from '@mdi/js';
import { Button, Stack } from '@mui/material';

interface IFileExplorerButtonProps {
    label: string;
    onFileInput: (files: File[]) => void;
    acceptFileTypes: string;
    allowMultiple?: boolean;
    colorVariant?: 'inherit' | 'primary' | 'secondary' | 'success' | 'error' | 'info' | 'warning';
}

export default ({
    label,
    onFileInput,
    acceptFileTypes,
    allowMultiple,
    colorVariant,
}: IFileExplorerButtonProps) => {
    const inputRef = useRef<HTMLInputElement>();

    const onFileInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (e.target.files?.length) {
            onFileInput(Array.from(e.target.files));
        }
    };

    return (
        <Stack direction='row'>
            <Button
                onClick={() => inputRef.current?.click()}
                startIcon={<Icon path={mdiPlusCircleOutline} size={1.0} />}
                sx={{ my: '16px 0px', textTransform: 'none' }}
                color={colorVariant ?? 'primary'}
            >
                {label}
                <input
                    ref={inputRef}
                    hidden
                    multiple={allowMultiple ?? true}
                    type='file'
                    accept={acceptFileTypes}
                    onChange={onFileInputChange}
                />
            </Button>
        </Stack>
    );
};
